import { getItemFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

export const collectionToRoute = {
  projects: "/work/projects",
  jobs: "/work/projects",
  tickets: "/support/all-tickets",
  job_extensions: "/work/projects",
  billables: "/work/billables",
};

export const useProjectData = (projectId) => {
  return useQuery({
    queryKey: ["notifications", "projects", projectId],
    queryFn: () =>
      getItemFromCollection("projects", projectId, { fields: ["project_id"] }),
    enabled: !!projectId,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useJobData = (jobId) => {
  return useQuery({
    queryKey: ["notifications", "jobs", jobId],
    queryFn: () =>
      getItemFromCollection("jobs", jobId, {
        fields: ["id", "project.project_id"],
      }),
    enabled: !!jobId,
    staleTime: 0,
    cacheTime: 0,
  });
};
